import React, { useState } from "react";
import styles from "./Contato.module.css";

export default function Contact() {
    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        celular: "",
        portaria: "",
        comentario: "",
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleRadioChange = (e) => {
        setFormData({ ...formData, portaria: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const { nome, email, celular, portaria, comentario } = formData;

        // Criação da mensagem para o WhatsApp
        const message = `Olá, gostaria de entrar em contato!%0A%0A` +
            `*Nome:* ${nome}%0A` +
            `*Email:* ${email}%0A` +
            `*Celular:* ${celular}%0A` +
            `*Possui portaria eletrônica?* ${portaria}%0A` +
            `*Mais detalhes:* ${comentario || "Nenhum"}`;

        // URL do WhatsApp com a mensagem
        const whatsappUrl = `https://wa.me/5585986051456?text=${message}`;

        // Redireciona para o WhatsApp
        window.open(whatsappUrl, "_blank");
    };

    return (
        <section className={styles.contactSection}>
            <div className={styles.contactContainer}>
                <div className={styles.contactLeft}>
                    <h2 className={styles.sectionTitlePrimary}>Fale conosco</h2>
                    <div className={styles.contactInfo}>
                        <a
                            href="mailto:guardaigestao@gmail.com"
                            className={styles.contactEmail}
                        >
                            guardaigestao@gmail.com
                        </a>
                        <a
                            href="https://wa.me/5585986051456"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.contactWhatsApp}
                        >
                            Inicie uma conversa no Whatsapp
                        </a>
                    </div>
                    <h2 className={styles.sectionTitlePrimary}>Horários de atendimento</h2>
                    <p>De segunda a sexta-feira, das 08h às 17h30.</p>
                    <h2 className={styles.sectionTitlePrimary}>Fábrica e Escritório central</h2>
                    <p>Fortaleza-CE</p>
                </div>

                <div className={styles.contactRight}>
                    <h2 className={styles.sectionTitlePrimary}>Preencha o formulário</h2>
                    <p>Entraremos em contato com você.</p>
                    <form onSubmit={handleSubmit} className={styles.contactForm}>
                        <div className={styles.formGroup}>
                            <label htmlFor="nome">Nome:</label>
                            <input
                                type="text"
                                id="nome"
                                placeholder="Digite seu nome"
                                value={formData.nome}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="email">Email:</label>
                            <input
                                type="email"
                                id="email"
                                placeholder="Digite seu email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="celular">Celular:</label>
                            <input
                                type="tel"
                                id="celular"
                                placeholder="Digite seu celular"
                                value={formData.celular}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>Possui portaria eletrônica?</label>
                            <div className={styles.radioContainer}>
                                <div>
                                    <input
                                        type="radio"
                                        id="sim"
                                        name="portaria"
                                        value="Sim"
                                        checked={formData.portaria === "Sim"}
                                        onChange={handleRadioChange}
                                        required
                                    />
                                    <label htmlFor="sim">Sim</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="nao"
                                        name="portaria"
                                        value="Não"
                                        checked={formData.portaria === "Não"}
                                        onChange={handleRadioChange}
                                        required
                                    />
                                    <label htmlFor="nao">Não</label>
                                </div>
                            </div>
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="comentario">Mais detalhes:</label>
                            <textarea
                                id="comentario"
                                placeholder="Espaço para comentários livres =)"
                                value={formData.comentario}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                        <button type="submit" className={styles.submitButton}>
                            Enviar
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
}
